export class Origem  {
    id: number;    
	descricao: string;    
}